import { useEffect, useState } from "react";
import "./NumberLoader.scss";
import { Box, Typography } from "@mui/material";

interface RollingNumberLoaderProps {
  isLoading: boolean;
}

export function RollingNumberLoader({ isLoading }: RollingNumberLoaderProps) {
  const [displayedValue, setDisplayedValue] = useState<number | string>("...");

  useEffect(() => {
    let intervalId: any;

    intervalId = setInterval(() => {
      const fakeValue = Math.floor(Math.random() * 100);
      setDisplayedValue(fakeValue);
    }, 60);
  }, [isLoading]);

  return (
    <>
      <Box className="rolling-number">{displayedValue}</Box>
    </>
  );
}
